export const translationDe_AT_Gilde = {
    translation: {
        entity: {
            job: 'Funktion',
        },
        property: {
            membership: {
                paymentTroop: 'Mitgliedsbeitrag Gilde',
                paymentDivision: 'Mitgliedsbeitrag Gildedistrikt',
                paymentFederation: 'Mitgliedsbeitrag Gildeverband',
                newsletterTroop: 'Zeitungsbezug Gilde',
                newsletterDivision: 'Zeitungsbezug Gildedistrikt',
                mailingTroop: 'Zusendungen Gilde',
                mailingDivision: 'Zusendungen Gildedistrikt',
            }
        },
        enum: {
            organizationLevel: {
                undefined: '',
                TROOP: 'Gilde',
                TROOP_other: 'Gilden',
                DIVISION: 'Gildedistrikt',
                DIVISION_other: 'Gildedistrikte',
                FEDERATION: 'Gildeverband',
                UNDEFINED: 'Organisation',
            },
            organizationLevelAbbreviation: {
                FEDERATION: 'Verband',
                DIVISION: 'Distrikt',
                TROOP: 'Gilde',
                UNDEFINED: 'Org.',
            }
        },
        visibility: {
            organizationOverview: {
                abbreviation: 'false',
            }
        },
    }
}